/**
 * The countries offered in the checkout. Static on purpose: provider coverage
 * is decided server-side, and a list fetched from anywhere would be one more
 * thing a page could influence.
 */
export const COUNTRIES: readonly string[] = [
  'BH', 'AE', 'SA', 'KW', 'QA', 'OM', 'GB', 'IE', 'DE', 'FR', 'NL', 'BE', 'LU', 'ES', 'PT', 'IT',
  'AT', 'CH', 'DK', 'SE', 'NO', 'FI', 'PL', 'CZ', 'GR', 'US', 'CA', 'AU', 'SG', 'IN', 'BR', 'JP',
];

export const DEFAULT_COUNTRY = 'AE';

export function defaultCountry(language: string | undefined): string {
  if (language) {
    const match = /[-_]([A-Za-z]{2})(?:$|[-_])/.exec(language);
    const region = match ? match[1].toUpperCase() : null;
    if (region && COUNTRIES.includes(region)) return region;
  }
  return DEFAULT_COUNTRY;
}

export function countryOptions(language: string | undefined): Array<{ code: string; label: string }> {
  let names: Intl.DisplayNames | null = null;
  try {
    names = new Intl.DisplayNames(language ? [language, 'en'] : ['en'], { type: 'region' });
  } catch {
    names = null;
  }
  return COUNTRIES.map((code) => ({ code, label: names?.of(code) ?? code })).sort((a, b) =>
    a.label.localeCompare(b.label)
  );
}
